import Highcharts from "highcharts";
import modules from "./modules";
import plugins from "./plugins";
import etc from "./etc";
modules(Highcharts);
plugins(Highcharts);
etc(Highcharts);
export default Highcharts;
